import { useRef, useEffect } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';

function AutoResizeTextarea({ value, name, readOnly = true, className = "", ...props }) {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
        }
    }, [value]);

    return (
        <textarea
             name={name}
            value={value || ''}
            style={{fieldSizing: 'content'}}
            className={`block text-gray-800 bg-white py-0.5 text-sm w-full text-left resize-none ${className}`}
        />
    );
}

export default AutoResizeTextarea;
